import * as React from 'react';
import { Tabs as Tablist } from '../Tabs/Tabs';
import { KEYS } from '../../common/keyCodes';
import { st, classes } from './TabbedContent.st.css';
import { TABBED_CONTENT_HOOKS } from './constants';
export const TabbedContent = ({ children, items, activeTabIndex, className, 'data-hook': dataHook, ...props }) => {
    const activeContentRef = React.useRef();
    const handleFocus = (e) => {
        if (e.key === KEYS.Tab && e.target !== e.currentTarget) {
            e.preventDefault();
            activeContentRef?.current.focus();
        }
    };
    const getHook = (idx) => {
        if (idx === activeTabIndex) {
            return `${TABBED_CONTENT_HOOKS.activeContentContainer} ${TABBED_CONTENT_HOOKS.contentContainer}-${idx}`;
        }
        return `${TABBED_CONTENT_HOOKS.contentContainer}-${idx}`;
    };
    return (React.createElement("div", { className: classes.componentWrapper, "data-hook": dataHook },
        React.createElement(Tablist, { className: st(classes.root, className), items: items, activeTabIndex: activeTabIndex, ...props, onKeyDown: handleFocus, isTablist: true }),
        items.map((item, idx) => (React.createElement("div", { className: classes.contentWrapper, role: "tabpanel", id: `${item.id}-tab`, ref: idx === activeTabIndex ? activeContentRef : null, key: item.id, hidden: idx !== activeTabIndex, tabIndex: -1, "aria-labelledby": item.id, "data-hook": getHook(idx) }, children(idx))))));
};
TabbedContent.displayName = 'TabbedContent';
//# sourceMappingURL=TabbedContent.js.map